/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Lembaga_A2dInputs */

const en_mk_sol_lembaga_a2d = /** @type {(inputs: Mk_Sol_Lembaga_A2dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drafts public material in the stored voice, always through an approval.`)
};

const id_mk_sol_lembaga_a2d = /** @type {(inputs: Mk_Sol_Lembaga_A2dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menyusun draf materi publik dengan nada yang tersimpan, selalu lewat approval.`)
};

/**
* | output |
* | --- |
* | "Drafts public material in the stored voice, always through an approval." |
*
* @param {Mk_Sol_Lembaga_A2dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_lembaga_a2d = /** @type {((inputs?: Mk_Sol_Lembaga_A2dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Lembaga_A2dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_lembaga_a2d(inputs)
	return en_mk_sol_lembaga_a2d(inputs)
});